import { inputService } from "./InputService";
export var InputKeyDetailsDeviceEnum;
(function (InputKeyDetailsDeviceEnum) {
    InputKeyDetailsDeviceEnum[InputKeyDetailsDeviceEnum["Keyboard"] = 0] = "Keyboard";
    InputKeyDetailsDeviceEnum[InputKeyDetailsDeviceEnum["Mouse"] = 1] = "Mouse";
    InputKeyDetailsDeviceEnum[InputKeyDetailsDeviceEnum["VRController"] = 2] = "VRController";
    InputKeyDetailsDeviceEnum[InputKeyDetailsDeviceEnum["Gamepad"] = 3] = "Gamepad";
})(InputKeyDetailsDeviceEnum || (InputKeyDetailsDeviceEnum = {}));
export var InputKeyDetailsFlags;
(function (InputKeyDetailsFlags) {
    InputKeyDetailsFlags[InputKeyDetailsFlags["Axis1D"] = 1] = "Axis1D";
    InputKeyDetailsFlags[InputKeyDetailsFlags["Axis2D"] = 1] = "Axis2D";
    InputKeyDetailsFlags[InputKeyDetailsFlags["Key"] = 1] = "Key";
})(InputKeyDetailsFlags || (InputKeyDetailsFlags = {}));
export class InputKeyDetails {
    constructor(keyName, descriptionName, indexMapping, deviceType, flags) {
        this.keyName = keyName;
        this.descriptionName = descriptionName;
        this.indexMapping = indexMapping;
        this.deviceType = deviceType;
        this.flags = flags;
    }
    getAxisValue(config) {
        switch (this.deviceType.type) {
            case InputKeyDetailsDeviceEnum.Keyboard:
                let result = false;
                if (this.deviceType.key) {
                    result = inputService.isKeyDown(this.deviceType.key);
                    if (!result)
                        return 0;
                }
                if (this.deviceType.code) {
                    result = inputService.isKeyDownByCode(this.deviceType.code);
                }
                return result ? 1 : 0;
            case InputKeyDetailsDeviceEnum.Mouse:
                let value = 0;
                if (this.flags === InputKeyDetailsFlags.Key) {
                    if (this.deviceType.buttonIndex !== undefined) {
                        value += inputService.isMouseButtonDown(this.deviceType.buttonIndex) ? 1 : 0;
                    }
                }
                if (this.flags === InputKeyDetailsFlags.Axis1D) {
                    switch (this.keyName) {
                        case "MouseX":
                            if (inputService.isMouseButtonDown(0)) {
                                value -= inputService.mouseMovement.x;
                            }
                            break;
                        case "MouseY":
                            if (inputService.isMouseButtonDown(0)) {
                                value -= inputService.mouseMovement.y;
                            }
                            break;
                        case "MouseWheel":
                            value -= inputService.mouseScrollDelta.y;
                    }
                }
                return value;
            case InputKeyDetailsDeviceEnum.VRController:
                return 0;
            case InputKeyDetailsDeviceEnum.Gamepad: {
                let value = 0;
                for (let i = 0; i < 4; ++i) {
                    value += inputService.gamepadsDevice.getAxisValue(i, this.keyName, config, this.deviceType.axisIndex, this.deviceType.buttonIndex);
                }
                return value;
            }
        }
    }
}
